/** Types that auto-check gaps from answers in the exercise body. */
export const THREE_ATTEMPTS_TYPES = [
    'fill_gaps',
    'fill_gaps_words',
    'fill_gaps_choice',
    'image_fill_gaps',
    'multiple_choice_short',
    'error_correction',
];

export const THREE_ATTEMPTS_MAX = 3;

export function isThreeAttemptsEnabled(exercise) {
    if (!exercise || exercise.assessment?.threeAttempts !== true) return false;
    return THREE_ATTEMPTS_TYPES.includes(exercise.type);
}

/** Ordered attempt outcomes for one gap (index 0 = first/bottom attempt). */
export function getGapAttemptResults(gapAttempts, idx) {
    if (!gapAttempts || typeof gapAttempts !== 'object') return [];
    const raw = gapAttempts[idx] ?? gapAttempts[String(idx)];
    if (!Array.isArray(raw)) return [];
    return raw.filter((v) => v === true || v === false).slice(0, THREE_ATTEMPTS_MAX);
}

/**
 * Record one attempt outcome.
 * @returns {{ results: boolean[], lock: boolean, clearAnswer: boolean, isCorrect: boolean|null }}
 */
export function applyGapAttempt(prevResults, isCorrect) {
    const prev = Array.isArray(prevResults)
        ? prevResults.filter((v) => v === true || v === false).slice(0, THREE_ATTEMPTS_MAX)
        : [];
    if (prev.length >= THREE_ATTEMPTS_MAX || prev.some((v) => v === true)) {
        return {
            results: prev,
            lock: true,
            clearAnswer: false,
            isCorrect: prev.some((v) => v === true),
        };
    }
    const results = [...prev, !!isCorrect];
    const done = !!isCorrect || results.length >= THREE_ATTEMPTS_MAX;
    return {
        results,
        lock: done,
        clearAnswer: !isCorrect && !done,
        isCorrect: done ? !!isCorrect : null,
    };
}

export function setGapAttemptResults(gapAttempts, idx, results) {
    const next = { ...(gapAttempts || {}) };
    next[idx] = results;
    next[String(idx)] = results;
    return next;
}
